import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { Carousel, CarouselBD, CarouselSend } from '../_model/carousel';
import { Media } from '../_model/media';
import { CarouselService } from '../_services/carousel.service';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-insertCarousel',
    templateUrl: './insertCarousel.component.html',
    styleUrls: ['./insertCarousel.component.less'],
    standalone: false
})
export class InsertCarouselComponent implements OnInit {

  faTimes = faTimes;

  constructor(private carousel: CarouselService,private sanatizer: DomSanitizer) { }

  model: CarouselSend = new CarouselSend();
  media: Media[] = [];

  ngOnInit() {
    this.model.userId = localStorage.getItem("userId");
    this.media = [];
    this.carousel.list().subscribe((data: any[]) => {
      var temp: Media[] = [];
      data.forEach(el => {
        this.carousel.media(el.file).subscribe((data2: Media) => {
          temp.push(data2);
          this.media = [];
          data.forEach(el => {
            temp.forEach(e => {
              if(el.file.includes(e.name)) {
                this.media.push(e);
              }
            });
          });
        });
      });
    });
  }

  pop(i: number) {
    this.media.splice(i,1);
  }

  sendCarousel() {
    var order = 0;
    this.model.media = [];
    this.media.forEach(el => {
      this.model.media.push(new Carousel({
        order: order,
        file: el
      }));
      order++;
    });
    this.carousel.send(this.model).subscribe(() => {
      this.model = new CarouselSend();
      this.model.userId = localStorage.getItem("userId");
      this.media = [];
      this.carousel.list().subscribe((data: any[]) => {
        var temp: Media[] = [];
        data.forEach(el => {
          this.carousel.media(el.file).subscribe((data2: Media) => {
            temp.push(data2);
            this.media = [];
            data.forEach(el => {
              temp.forEach(e => {
                if(el.file.includes(e.name)) {
                  this.media.push(e);
                }
              });
            });
          });
        });
      });
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Carrousel actualizado com sucesso</h1>",
        position: "top-end",
        timer: 1500,
        icon: 'success',
        showConfirmButton: false,
        customClass: {
          popup: 'card-border-gold',
        }
      });
    });
  }

  catchEvent(ev) {
    console.log(this.media);
  }

  isBase64(str: any) {
    var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    return base64regex.test(str);
  }
  Uint8ArrayToString(dataI: any) {
    var data = new Uint8Array(dataI);
    var CHUNK_SZ = 0x8000;
    var c = [];
    for (var i=0; i < data.length; i+=CHUNK_SZ) {
      c.push(String.fromCharCode.apply(null, data.subarray(i, i+CHUNK_SZ)));
    }
    return c.join("");
  }
  sendUrl(file: Media) {
    return this.sanatizer.bypassSecurityTrustUrl("data:image/"+file.name.split(".")[file.name.split(".").length-1]+";base64,"+(this.isBase64(file.file) ? file.file : btoa(this.Uint8ArrayToString(file.file))));
  }

  drop(event: CdkDragDrop<Media[]>) {
    moveItemInArray(this.media, event.previousIndex, event.currentIndex);
  }

}
